<template>
  <div class="product-element q-p-1 q-p-sm-2 q-pb-3 " :data-id="id">
    <div class="product-element__container q-card q-h-100 q-shadow-sm q-rounded-2 q-position-relative">
      <div class="product-element__image-container q-card-image">
        <img class="product-element__image mx-auto q-d-block q-card-img-top q-img-fluid"
             v-lazy="staticImage"
             :alt="title"/>
      </div>
      <div class="product-element__info-box q-card-body q-p-2">
        <h6 class="product-element__title q-fw-normal q-small">{{ title }}</h6>
      </div>
      <a class="product-element__link q-stretched-link" :href="actualLink" ></a>
    </div>
  </div>
</template>
<script setup lang="ts">
import {defineProps, toRefs, ref} from 'vue'
import {generateStaticImage} from "@/core/utils";
import {config} from "@/core/config";

const {getTheLookUrl} = config

const props = defineProps(['product', 'component']);
const {id, link, title, link_click, variants} = toRefs(props.product);
const firstVariant = ref(variants.value[0]).value
const staticImage = ref(generateStaticImage(firstVariant.image_link, 300, null));
const actualLink = ref(`${getTheLookUrl}${config.useHashBeforeParams ? '#': ''}?stylisation=${id.value}`)

</script>